import React from "react";

// Landing
const Landing = ({ language }) => {
  return (
    <React.Fragment>
      <main className="landing-page">
        <section
          className="hero"
          style={{
            background: `url("../../images/pages/landing/hero-bg-3.webp")`,
            backgroundSize: "cover",
            backgroundPosition: "center left",
          }}
        >
          <div className="logo-box">
            <img
              src="../../images/pages/landing/hero-img-1.webp"
              alt=""
              className="logo"
            />

            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27.998"
                height="28.081"
                viewBox="0 0 27.998 28.081"
              >
                <path
                  d="M26.8,24,37.4,13.5a2.1,2.1,0,0,0,.2-2.7,1.9,1.9,0,0,0-3-.2L24,21.2,13.4,10.6a1.9,1.9,0,0,0-3,.2,2.1,2.1,0,0,0,.2,2.7L21.2,24,10.6,34.5a2.1,2.1,0,0,0-.2,2.7,1.9,1.9,0,0,0,3,.2L24,26.8,34.6,37.4a1.9,1.9,0,0,0,3-.2,2.1,2.1,0,0,0-.2-2.7Z"
                  transform="translate(-10.001 -9.959)"
                  fill="#fffbfb"
                />
              </svg>
            </span>

            <img
              src="../../images/pages/landing/hero-img-2.webp"
              alt=""
              className="logo"
            />

            <div className="text-box">
              <div className="text-box-container">
                <p>
                  {language === "english" ? (
                    <React.Fragment>
                      Bitcoin Legend's hero card concept is that anyone in
                      general can become a hero. Maxform NFT Hero Card was
                      developed by the BitcoinLegend Core team It was composed
                      of UNIQUE DIGITAL COLLECTIBLES on the Ethereum blockchain
                      ERC-721. Five heroes are reborn with NFT cards. It is
                      designed with the concept that any ordinary person can
                      become a hero. <br />
                      <br /> It's half normal clothing and half in hero
                      clothing. This is made even more unique by the rarity
                      program. There is no identical form among the issued
                      cards. Hair, clothing, weapons, accessories, mask,
                      background, etc. item items are all different. Among them,
                      there is not one character but a total of 5 characters in
                      different poses and postures. For each such character,
                      2000 hero cards are issued. <br />
                      <br /> The approach is different from other NFTs that
                      create 10,000 pieces with one character. In this way, a
                      total of five characters appearing in 2000 each, making a
                      total of 10,000 cards. You will have your rare and unique
                      item.
                    </React.Fragment>
                  ) : language === "korean" ? (
                    <React.Fragment>
                      Bitcoin Legend의 히어로카드 개념은 누구나 일반인도 영웅이
                      될 수 있다는 것입니다. Maxform NFT Hero Card는
                      BitcoinLegend Core 팀에서 개발했습니다. 이더리움 블록체인
                      ERC-721의 UNIQUE DIGITAL COLLECTIBLES로 구성되어
                      있었습니다. 5명의 히어로가 NFT 카드로 다시 태어났습니다.
                      일반인도 히어로가 될 수 있다는 컨셉으로 디자인되었습니다.
                      반은 일반 복장, 반은 히어로 복장입니다. 이것은 희귀
                      프로그램에 의해 더욱 유니크해 졌습니다. 발급된 카드 중
                      동일한 형태가 없습니다. 헤어, 의상, 무기, 악세서리,
                      마스크, 배경 등 아이템 아이템이 모두 다릅니다. 그 중
                      캐릭터는 한 명도 아닌 총 5명의 캐릭터가 각기 다른 포즈를
                      취하고 있다. 각 캐릭터마다 2,000장의 히어로카드가
                      발행됩니다. 한 캐릭터로 10,000개의 조각을 만드는 다른
                      NFT와 접근 방식이 다릅니다. 이렇게 해서 각각 2,000장씩 총
                      5명의 캐릭터가 등장하여 총 10,000장의 카드를 만들어
                      졌습니다. 당신은 당신의 희귀하고 독특한 아이템을 갖게 될
                      것입니다.
                    </React.Fragment>
                  ) : language === "chinese" ? (
                    <React.Fragment>
                      比特币传奇的英雄卡概念是任何人都可以成为英雄。 Maxform NFT
                      英雄卡由 BitcoinLegend Core 团队开发。 它由以太坊区块链
                      ERC-721 上的 UNIQUE DIGITAL COLLECTIBLES 组成。
                      五位英雄凭借 NFT
                      卡重生。它的设计理念是任何普通人都可以成为英雄。
                      一半是普通服装，一半是英雄服装。
                      稀有程序使这变得更加独特。发行的卡之间没有相同的形式。头发、衣服、武器、配饰、面具、背景等等物品物品都是不同的。
                      其中，不是一个角色，而是共有5个不同姿势的角色。
                      对于每个这样的角色，将发行 2,000 张英雄卡。 这种方法与其他
                      NFT 不同，它使用一个字符创建 10,000 件。
                      这样一来，总共出现了5个角色，每人2000个，一共制作了10000张卡片。
                      您将拥有稀有而独特的物品.
                    </React.Fragment>
                  ) : language === "vietnamese" ? (
                    <React.Fragment>
                      Khái niệm thẻ anh hùng của Bitcoin Legend là bất kỳ ai nói
                      chung đều có thể trở thành anh hùng. Thẻ Maxform NFT Hero
                      được phát triển bởi nhóm BitcoinLegend Core. Nó bao gồm
                      các BỘ SƯU TẬP KỸ THUẬT SỐ DUY NHẤT trên chuỗi khối
                      Ethereum ERC-721. Năm anh hùng được tái sinh với thẻ NFT.
                      Nó được thiết kế với quan niệm rằng bất kỳ người bình
                      thường nào cũng có thể trở thành anh hùng. Đó là một nửa
                      quần áo bình thường và một nửa trang phục anh hùng. Điều
                      này thậm chí còn độc đáo hơn bởi chương trình hiếm. Không
                      có hình thức giống nhau giữa các thẻ đã phát hành. Tóc,
                      quần áo, vũ khí, phụ kiện, mặt nạ, bối cảnh, v.v. các mặt
                      hàng vật phẩm đều khác nhau. Trong số đó, không có một
                      nhân vật nào mà có tổng cộng 5 nhân vật ở các tư thế khác
                      nhau. Đối với mỗi nhân vật như vậy, 2.000 thẻ anh hùng
                      được phát hành. Cách tiếp cận khác với các NFT khác là tạo
                      ra 10.000 mảnh với một ký tự. Theo cách này, tổng cộng năm
                      nhân vật xuất hiện trong 2000 mỗi nhân vật, được tạo ra
                      với tổng số 10.000 thẻ. Bạn sẽ có vật phẩm hiếm và độc
                      nhất của mình.
                    </React.Fragment>
                  ) : language === "arabic" ? (
                    <React.Fragment>
                      مفهوم بطاقة بطل Bitcoin Legend هو أن أي شخص بشكل عام يمكن
                      أن يصبح بطلاً. تم تطوير بطاقة Maxform NFT Hero Card بواسطة
                      فريق BitcoinLegend Core. كان يتألف من مجموعات رقمية فريدة
                      من نوعها على Ethereum blockchain ERC-721. خمسة أبطال
                      يولدون من جديد ببطاقات NFT. إنه مصمم بمفهوم أن أي شخص عادي
                      يمكن أن يصبح بطلاً. إنها نصف ملابس عادية ونصفها في ملابس
                      البطل. أصبح هذا أكثر تميزًا من خلال برنامج الندرة. لا يوجد
                      شكل متطابق بين البطاقات الصادرة. الشعر ، والملابس ،
                      والأسلحة ، والإكسسوارات ، والقناع ، والخلفية ، وما إلى ذلك
                      عناصر العناصر كلها مختلفة. من بينها ، لا توجد شخصية واحدة
                      ولكن ما مجموعه 5 أحرف في أوضاع مختلفة. لكل شخصية من هذا
                      القبيل ، يتم إصدار 2000 بطاقة بطل. يختلف الأسلوب عن NFTs
                      الأخرى التي تصنع 10000 قطعة بحرف واحد. بهذه الطريقة ، يظهر
                      إجمالي خمسة أحرف في عام 2000 لكل منها ، ليصبح إجمالي
                      البطاقات 10000 بطاقة. سيكون لديك البند الخاص بك نادر وفريد
                      ​​من نوعه.
                    </React.Fragment>
                  ) : null}
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
};

// Export
export default Landing;
